import Icon from '../components/Icon.vue'

Icon.register({
  'arrows-alt-h': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M377.9 169.9V216H134.1V169.9C134.1 148.6 108.2 137.9 93.1 153L7 239C-2.3 248.4-2.3 263.6 7 273L93.1 359C108.2 374.1 134.1 363.4 134.1 342.1V296H377.9V342.1C377.9 363.4 403.8 374.1 418.9 359L505 273C514.3 263.6 514.3 248.4 505 239L418.9 153C403.8 137.9 377.9 148.6 377.9 169.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrows-alt-h.js
// module id = DhXV
// module chunks = 144